import React from "react";
import { Box } from "../Box";
import { FinishModal } from "../FinishModal";
import { Column, Row, Spacer } from "./style";

export const Play: React.FC = () => {
  return (
    <>
      <Row>
        {/* Bさんのゴールのボックス */}
        <Column>
          <Box id={13} isGoal />
          <Spacer />
        </Column>
        {/* 真ん中のボックス */}
        <Column>
          <Box id={12} />
          <Spacer />
          <Box id={0} />
        </Column>
        <Column>
          <Box id={11} />
          <Spacer />
          <Box id={1} />
        </Column>
        <Column>
          <Box id={10} />
          <Spacer />
          <Box id={2} />
        </Column>
        <Column>
          <Box id={9} />
          <Spacer />
          <Box id={3} />
        </Column>
        <Column>
          <Box id={8} />
          <Spacer />
          <Box id={4} />
        </Column>
        <Column>
          <Box id={7} />
          <Spacer />
          <Box id={5} />
        </Column>
        {/* Aさんのゴールのボックス */}
        <Column>
          <Spacer />
          <Box id={6} isGoal />
        </Column>
      </Row>
      {/* モーダル */}
      <FinishModal />
    </>
  );
};
